import { ObjectField, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class TubularOperator extends ObjectField {
    static create(construct) {
        return new TubularOperator(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get rate1() {
        return this.getField(1);
    }
    get rate2() {
        return this.getField(2);
    }
    get rate3() {
        return this.getField(3);
    }
    get rate4() {
        return this.getField(4);
    }
    get level1() {
        return this.getField(5);
    }
    get level2() {
        return this.getField(6);
    }
    get level3() {
        return this.getField(7);
    }
    get level4() {
        return this.getField(8);
    }
    get breakPoint() {
        return this.getField(9);
    }
    get leftDepth() {
        return this.getField(10);
    }
    get rightDepth() {
        return this.getField(11);
    }
    get leftCurve() {
        return this.getField(12);
    }
    get rightCurve() {
        return this.getField(13);
    }
    get rateScaling() {
        return this.getField(14);
    }
    get ampModSens() {
        return this.getField(15);
    }
    get velocitySens() {
        return this.getField(16);
    }
    get outputLevel() {
        return this.getField(17);
    }
    get mode() {
        return this.getField(18);
    }
    get coarse() {
        return this.getField(19);
    }
    get fine() {
        return this.getField(20);
    }
    get detune() {
        return this.getField(21);
    }
    get enabled() {
        return this.getField(22);
    }
    initializeFields() {
        return {
            1: Int32Field.create({
                parent: this,
                fieldKey: 1,
                fieldName: "rate1",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "rate2",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            3: Int32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "rate3",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            4: Int32Field.create({
                parent: this,
                fieldKey: 4,
                fieldName: "rate4",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "level1",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            6: Int32Field.create({
                parent: this,
                fieldKey: 6,
                fieldName: "level2",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            7: Int32Field.create({
                parent: this,
                fieldKey: 7,
                fieldName: "level3",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 99),
            8: Int32Field.create({
                parent: this,
                fieldKey: 8,
                fieldName: "level4",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            9: Int32Field.create({
                parent: this,
                fieldKey: 9,
                fieldName: "breakPoint",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "leftDepth",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            11: Int32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "rightDepth",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            12: Int32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "leftCurve",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 3 }, "", 0),
            13: Int32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "rightCurve",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 3 }, "", 0),
            14: Int32Field.create({
                parent: this,
                fieldKey: 14,
                fieldName: "rateScaling",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 7 }, "", 0),
            15: Int32Field.create({
                parent: this,
                fieldKey: 15,
                fieldName: "ampModSens",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 3 }, "", 0),
            16: Int32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "velocitySens",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 7 }, "", 0),
            17: Int32Field.create({
                parent: this,
                fieldKey: 17,
                fieldName: "outputLevel",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            18: Int32Field.create({
                parent: this,
                fieldKey: 18,
                fieldName: "mode",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 1 }, "", 0),
            19: Int32Field.create({
                parent: this,
                fieldKey: 19,
                fieldName: "coarse",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 31 }, "", 1),
            20: Int32Field.create({
                parent: this,
                fieldKey: 20,
                fieldName: "fine",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 99 }, "", 0),
            21: Int32Field.create({
                parent: this,
                fieldKey: 21,
                fieldName: "detune",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 14 }, "", 7),
            22: Int32Field.create({
                parent: this,
                fieldKey: 22,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 1 }, "", 1),
        };
    }
}
